module.exports = "---\ntitle: \"画廊\"\ntime: \"2024-10-07\"\n---\n\n“画廊”功能正式上线！此板块主要包含了一些对我来说很有意义的图片，仅作为记录使用。（多图杀猫）\n";